var map = {
	"./texts.de-de": [
		6935,
		935
	],
	"./texts.de-de.ts": [
		6935,
		935
	],
	"./texts.el-gr": [
		7,
		7
	],
	"./texts.el-gr.ts": [
		7,
		7
	],
	"./texts.es-es": [
		5994,
		613
	],
	"./texts.es-es.ts": [
		5994,
		613
	],
	"./texts.fr-fr": [
		4241,
		241
	],
	"./texts.fr-fr.ts": [
		4241,
		241
	],
	"./texts.it-it": [
		1367,
		367
	],
	"./texts.it-it.ts": [
		1367,
		367
	],
	"./texts.ro-ro": [
		519,
		519
	],
	"./texts.ro-ro.ts": [
		519,
		519
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9004;
module.exports = webpackAsyncContext;